<template>
  <table>
    <tr>
      <th>Name</th>
      <th>Price</th>
    </tr>
    <tr v-for="item in items" v-bind:table="item" v-bind:key="item.id">
      <td>{{ item.name }}</td>
      <td v-if="item.cost">₹{{ item.cost }} per {{ item.unit }}</td>
      <td v-if="!item.cost" class="warn">
        <a v-bind:href="generateMessage(item.name)">Get Best Price</a>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: "PriceSet",
  data: function() {
    return {
      items: [
        { id: 1, name: "Cardamom" },
        { id: 2, name: "Cloves" },
        { id: 3, name: "Black Pepper" },
        { id: 4, name: "Turmeric Powder" },
        { id: 5, name: "Chilli Powder" }
      ]
    };
  },
  methods: {
    generateMessage: function(itemName) {
      const phoneNumber = "0918280282808";
      const defaultMessage = `Hello I am interested in buying ${itemName}. What is it's current price?`;
      const whatsAppLink = `https://wa.me/${phoneNumber}?text=${encodeURI(
        defaultMessage
      )}`;
      return whatsAppLink;
    }
  }
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  text-align: center;
  border-radius: 6px;
  border-collapse: collapse;
  overflow: hidden;

  th,
  td {
    padding: 15px;
  }
  th {
    background: var(--table-head);
  }
  tr {
    &:not(:last-child) {
      border-bottom: 1px dashed var(--table-border);
    }
    &:nth-child(even) {
      background: var(--table-row);
    }
  }
  a {
    border-radius: 4px;
    border: 1px solid var(--base-text-color);
    color: var(--base-text-color);
    padding: 5px 10px;
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    display: inline-block;

    &:hover {
      background: var(--base-text-color);
      color: var(--base-bg);
    }
  }
}
</style>
